import styled from "styled-components";
import { Font, Color, breakpoints } from "@/shared/Constants";

export const ContainerAuto = styled.div`
  width: 1316px;
  margin: auto;

  &.container100 {
    width: 100%;
    margin: 0px;
    padding: 0;
  }
  &.container-vintage {
    width: 990px !important;
    ${breakpoints.phone} {
      width: 100% !important;
    }
  }

  ${breakpoints.smallDesktop} {
    width: 100%;
    margin: auto;
    padding: 0 12px;
    &.container-vintage {
      width: 990px;
      padding: 0;
    }
  }
  ${breakpoints.tablet} {
    width: 980px;
    padding: 0 12px;
    &.container-vintage {
      width: 990px;
      padding: 0;
    }
  }
  ${breakpoints.phone} {
    width: 100%;
    padding: 0 12px;
    &.container-vintage {
      width: 100%;
      padding: 0;
    }
  }
`;
